// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__16pKU","rightAdornment":"Header_rightAdornment__1ajl0"};